import { BaseAPIRequestFactory, RequiredError } from './baseapi.js';
import { HttpMethod, HttpInfo } from '../http/http.js';
import { ObjectSerializer } from '../models/ObjectSerializer.js';
import { ApiException } from './exception.js';
import { isCodeInRange } from '../util.js';
export class SamlCallbackApiRequestFactory extends BaseAPIRequestFactory {
    async sAMLCallback(sAMLResponse, relayState, _options) {
        let _config;
        if (!_options) {
            _config = this.configuration;
        }
        else {
            _config = Object.assign({}, _options, this.configuration);
        }
        if (sAMLResponse === null || sAMLResponse === undefined) {
            throw new RequiredError("SamlCallbackApi", "sAMLCallback", "sAMLResponse");
        }
        const localVarPath = '/saml/acs';
        let signal = _config.timeout ? AbortSignal.timeout(_config.timeout) : undefined;
        const requestContext = _config.baseServer.makeRequestContext(localVarPath, HttpMethod.POST, signal);
        requestContext.setHeaderParam("Accept", "application/json, */*;q=0.8");
        return requestContext;
    }
}
export class SamlCallbackApiResponseProcessor {
    async sAMLCallbackWithHttpInfo(response) {
        if (isCodeInRange("204", response.httpStatusCode)) {
            return new HttpInfo(response.httpStatusCode, response.headers, response.body, undefined);
        }
        if (isCodeInRange("302", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Redirect to the application home page or RelayState URL after successful authentication.", undefined, response.headers, response);
        }
        if (isCodeInRange("400", response.httpStatusCode)) {
            const body = ObjectSerializer.deserialize(await response.body.json(), "SAMLCallback400Response", "");
            throw new ApiException(response.httpStatusCode, "Bad request - invalid or missing SAML response", body, response.headers, response);
        }
        if (isCodeInRange("401", response.httpStatusCode)) {
            const body = ObjectSerializer.deserialize(await response.body.json(), "SAMLCallback401Response", "");
            throw new ApiException(response.httpStatusCode, "Unauthorized - SAML response validation failed", body, response.headers, response);
        }
        if (isCodeInRange("500", response.httpStatusCode)) {
            const body = ObjectSerializer.deserialize(await response.body.json(), "SAMLCallback500Response", "");
            throw new ApiException(response.httpStatusCode, "Internal server error", body, response.headers, response);
        }
        if (isCodeInRange("1XX", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Informational", undefined, response.headers, response);
        }
        if (isCodeInRange("3XX", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Redirect", undefined, response.headers, response);
        }
        if (isCodeInRange("4XX", response.httpStatusCode)) {
            const body = ObjectSerializer.deserialize(await response.body.json(), "Error", "");
            throw new ApiException(response.httpStatusCode, "Client Error", body, response.headers, response);
        }
        if (isCodeInRange("5XX", response.httpStatusCode)) {
            const body = ObjectSerializer.deserialize(await response.body.json(), "Error", "");
            throw new ApiException(response.httpStatusCode, "Internal Server Error", body, response.headers, response);
        }
        if (response.httpStatusCode < 200 || response.httpStatusCode > 299) {
            throw new ApiException(response.httpStatusCode, "Unknown API Status Code!", await response.getBodyAsAny(), response.headers, response);
        }
        const body = await response.body.json();
        return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
    }
}
